import React from "react";
import { ErrorBoundary, FallbackProps } from "react-error-boundary";
import ErrorFallback from "./ErrorFallback";

type WithErrorBoundaryOptions = {
  fallback?: React.ComponentType<FallbackProps>;
  onError?: (error: Error, info: { componentStack: string }) => void;
};

export function withErrorBoundary<P extends JSX.IntrinsicAttributes>(
  Component: React.ComponentType<P>,
  options?: WithErrorBoundaryOptions
): React.FC<P> {
  const {
    fallback: FallbackComponent = ErrorFallback,
    onError = (error: Error, info: { componentStack: string }) => {
      console.error("Error caught by withErrorBoundary:", error, info);
    },
  } = options || {};

  const Wrapped = (props: P) => (
    <ErrorBoundary FallbackComponent={FallbackComponent} onError={onError}>
      <Component {...props} />
    </ErrorBoundary>
  );

  return Wrapped;
}
